import { render, staticRenderFns } from "./BuildLoanContractForm.vue?vue&type=template&id=58f658da&"
import script from "./BuildLoanContractForm.vue?vue&type=script&lang=ts&"
export * from "./BuildLoanContractForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports